// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleLink_container__PzcqH","Main":"ArticleLink_Main__143LR","MastheadText":"ArticleLink_MastheadText__3mi2J","Background":"ArticleLink_Background__2aW6x"};